const doc = [({"en":({"js":({"admin":({"economy":({"accounts":({"account_plan":"Account plan", "account_types":"Account types"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;